import React from "react";

// Program component
export default function UGProgram(props) {
  const { program, onClick, isActive, className = "" } = props;

  return (
    <div
      onClick={onClick}
      className={`text-base py-3 px-8 w-full flex flex-row items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors ${
        isActive ? "bg-[#c9dbff73] text-primary-color" : "text-gray-600"
        } ${className}`}
    >
      <h2 className="text-left flex items-center gap-2">
        <span>{program.programName}</span>
        <span className="text-sm text-gray-400">({program.count})</span>
      </h2>
    </div>
  );
}
